module.exports = __webpack_public_path__ + "static/media/divided-spiral.a8e90e0d.svg";